(function () {
  function defaultQuestions() {
    return [
      {
        id: 'q1_form',
        type: 'single',
        scoringKey: 'form',
        text: 'How do you want to brew your coffee?',
        hint: 'About 60 seconds left',
        options: [
          { label: 'Whole bean or ground bags', value: 'bag' },
          { label: 'Single-serve pods (Keurig-compatible)', value: 'pod' },
          { label: 'Ready-to-drink / instant espresso', value: 'instant' },
          { label: 'Monthly subscription', value: 'subscription' }
        ]
      },
      {
        id: 'q2_drink',
        type: 'single',
        scoringKey: 'drink_styles',
        text: 'How do you usually drink your coffee?',
        hint: 'Almost halfway there',
        options: [
          { label: 'Black', value: 'black' },
          { label: 'With milk / cream / latte', value: 'milk' },
          { label: 'As espresso', value: 'espresso' },
          { label: 'Flavored or dessert-style', value: 'flavored' }
        ]
      },
      {
        id: 'q3_roast',
        type: 'single',
        scoringKey: 'roast',
        text: 'What roast level suits your taste?',
        hint: 'Three more to go',
        options: [
          { label: 'Light roast', value: 'light' },
          { label: 'Medium roast', value: 'medium' },
          { label: 'Dark roast', value: 'dark' },
          { label: 'Very dark roast', value: 'very-dark' },
          { label: 'Surprise me / not sure', value: 'any' }
        ]
      },
      {
        id: 'q4_flavor',
        type: 'single',
        scoringKey: 'flavor_profiles',
        text: 'Which flavor profile calls to you?',
        hint: 'One more after this',
        options: [
          { label: 'Fruity & bright', value: 'fruity' },
          { label: 'Chocolate, caramel & nutty', value: 'chocolate-caramel' },
          { label: 'Bold, smoky & classic', value: 'bold-smoky' },
          { label: 'Sweet & dessert-like', value: 'sweet-indulgent' }
        ]
      },
      {
        id: 'q5_caffeine',
        type: 'single',
        scoringKey: 'caffeine',
        text: 'Caffeine, please?',
        hint: 'Final question - promise',
        options: [
          { label: 'Full caffeine', value: 'regular' },
          { label: 'Decaf', value: 'decaf' },
          { label: 'Either', value: 'either' }
        ]
      }
    ];
  }

  function collectQuestions(root) {
    const source = root.querySelector('[data-quiz-question-source]');
    if (!source) return defaultQuestions();

    const questions = Array.from(source.children).map((node) => {
      const options = Array.from(node.querySelectorAll('[data-option-label]')).map((opt) => ({
        label: opt.getAttribute('data-option-label') || '',
        value: opt.getAttribute('data-option-value') || ''
      })).filter((opt) => opt.label && opt.value);

      return {
        id: node.getAttribute('data-question-id') || '',
        type: node.getAttribute('data-question-type') || 'single',
        scoringKey: node.getAttribute('data-scoring-key') || '',
        text: node.getAttribute('data-question-text') || '',
        hint: node.getAttribute('data-question-hint') || '',
        options
      };
    }).filter((question) => question.id && question.text && question.options.length);

    return questions.length ? questions : defaultQuestions();
  }

  function initQuiz(root) {
    const questions = collectQuestions(root);
    const resultUrl = root.getAttribute('data-result-url') || '';
    const missingResultUrlText = 'The result page could not be loaded.';
    const nextBtn = root.querySelector('[data-quiz-next]');
    const submitLabel = (nextBtn && nextBtn.getAttribute('data-submit-label')) || 'See my results';
    const nextLabel = (nextBtn && nextBtn.getAttribute('data-next-label')) || 'Next';

    const progressFill = root.querySelector('[data-quiz-progress-fill]');
    const stepLabel = root.querySelector('[data-quiz-step-label]');
    const stepHint = root.querySelector('[data-quiz-step-hint]');
    const questionEl = root.querySelector('[data-quiz-question]');
    const answersEl = root.querySelector('[data-quiz-answers]');
    const errorEl = root.querySelector('[data-quiz-error]');
    const backBtn = root.querySelector('[data-quiz-back]');
    

    let step = 0;
    const answers = {};

    function render() {
      const q = questions[step];
      const selected = answers[q.id];
      const total = questions.length;
      const answeredCount = Object.keys(answers).length;
      const ratio = Math.min(1, Math.max(0, answeredCount / total));
      progressFill.style.width = String(ratio * 100) + '%';
      stepLabel.innerHTML = 'Step <span class="num">' + String(step + 1).padStart(2, '0') + '</span> of ' + String(total).padStart(2, '0');
      if (stepHint) stepHint.textContent = q.hint || '';
      questionEl.textContent = q.text;
      answersEl.innerHTML = q.options
        .map((opt) => {
          const isSelected = selected === opt.value;
          return '<button type="button" class="custom-coffee-quiz__answer' + (isSelected ? ' is-selected' : '') + '" data-answer="' + opt.value + '">' + opt.label + '</button>';
        })
        .join('');
      backBtn.disabled = step === 0;
      nextBtn.textContent = step === total - 1 ? submitLabel : nextLabel;
      if (errorEl) errorEl.hidden = true;
    }

    function scoreAndRedirect() {
      const sel = {};
      questions.forEach((q) => {
        const key = q.scoringKey || (q.id ? q.id.replace(/^q\d+_/, '') : null);
        if (key && answers[q.id] !== undefined) sel[key] = answers[q.id];
      });

      if (!resultUrl) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = missingResultUrlText;
        }
        return;
      }

      const url = new URL(resultUrl, window.location.origin);
      if (sel.form)           url.searchParams.set('form',     sel.form);
      if (sel.caffeine)       url.searchParams.set('caffeine', sel.caffeine);
      if (sel.roast)          url.searchParams.set('roast',    sel.roast);
      if (sel.drink_styles)   url.searchParams.set('drink',    sel.drink_styles);
      if (sel.flavor_profiles) url.searchParams.set('flavor',  sel.flavor_profiles);
      window.location.href = url.toString();
    }

    answersEl.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-answer]');
      if (!btn) return;
      const q = questions[step];
      answers[q.id] = btn.getAttribute('data-answer');
      if (step < questions.length - 1) {
        step += 1;
      }
      render();
    });

    backBtn.addEventListener('click', () => {
      if (step <= 0) return;
      step -= 1;
      render();
    });

    nextBtn.addEventListener('click', () => {
      const q = questions[step];
      if (!answers[q.id]) {
        if (errorEl) errorEl.hidden = false;
        return;
      }
      if (step === questions.length - 1) {
        scoreAndRedirect();
        return;
      }
      step += 1;
      render();
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-custom-coffee-quiz-root]').forEach((root) => {
      if (root.dataset.init === 'true') return;
      root.dataset.init = 'true';
      initQuiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
